define('shared/my/accessToken/set',[
    'Promise',
    'shared/util/state',
    'shared/util/state/adapters/persistent',
    'shared/lib/console'
], function(Promise, state, persistentAdapter, console){
    var TIMEOUT_IN_MEMORY_TOKEN = 1000 * 5 * 60;
    var settingPromise;
    var MODULE_NAME = 'shared/my/accessTokenSet:';

    function setAccessToken(id) {
        if (settingPromise) {
            return settingPromise.then(function(){
                return setAccessToken(id);
            });
        }

        var ret = settingPromise = Promise.resolve()
            .then(function(){
                return state.adapters.add(persistentAdapter);
            })
            .then(function(){
                console.log(MODULE_NAME, 'Store access token', id);
                return state.push('persistent.accessToken', {
                    value: id,
                    date: {
                        expiration: (new Date(Date.now() + TIMEOUT_IN_MEMORY_TOKEN))
                    }
                });
            })
            .then(function(){
                settingPromise = null;
            }, function(){
                settingPromise = null;
            });

        return ret;
    }

    return setAccessToken;
});
